import React from "react";
import { useSelector } from "react-redux";

import { showGrade } from "../utils/textUtils";

const TopBar = ({ isMobile }) => {
  const { student } = useSelector((state) => state.student);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "1.5vw",
        borderBottom: "1px solid #EBEBEB",
        fontSize: isMobile ? "14px" : "18px",
        height: isMobile ? "40px" : "60px",
        backgroundColor: "#FFF",
      }}
    >
      {student.name} 과제 관리 시스템
    </div>
  );
};

export default TopBar;
